import { useNavigate } from 'react-router-dom'

import { env } from 'src/config/env'
import { paths } from 'src/config/paths'
import { CalendarOutline } from 'src/shared/components/icons/sidebar/calendar-outline'
import type { IconNavItem } from 'src/shared/components/ui/mobile-sidebar'
import MobileSidebar from 'src/shared/components/ui/mobile-sidebar'
import { CONSTANTS } from 'src/shared/constants/constants'

interface ProfessionalNavSidebarProps {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function ProfessionalNavSidebar({ isOpen, setIsOpen }: ProfessionalNavSidebarProps) {
  const navigate = useNavigate()

  const mainNavItems = [
    {
      label: 'Overview',
      onClick: () => {
        navigate(paths.professionals.overview.getHref())
        setIsOpen(false)
      },
    },
    {
      label: 'Solutions',
      onClickSubNavTitle: 'Solution',
    },
    {
      label: 'For homeowners',
      onClick: () => {
        navigate(paths.root.getHref())
        setIsOpen(false)
      },
    },
    {
      label: 'For companies',
      onClick: () => {
        navigate(paths.enterprise.getHref())
        setIsOpen(false)
      },
    },
  ]

  const nestedNavItems = [
    {
      title: 'Solution',
      items: [
        {
          label: 'Get more business',
          onClick: () => {
            navigate(paths.professionals.getMoreBusiness.getHref())
            setIsOpen(false)
          },
        },
        {
          label: 'Implement AI',
          onClick: () => {
            navigate(paths.professionals.implementAi.getHref())
            setIsOpen(false)
          },
        },
        {
          label: 'Convert more leads',
          onClick: () => {
            navigate(paths.professionals.convertMoreLeads.getHref())
            setIsOpen(false)
          },
        },
        {
          label: 'Run your business',
          onClick: () => {
            navigate(paths.professionals.runYourBusiness.getHref())
            setIsOpen(false)
          },
        },
        {
          label: 'Grow your network',
          onClick: () => {
            navigate(paths.professionals.growYourNetwork.getHref())
            setIsOpen(false)
          },
        },
      ],
    },
    // {
    //   title: 'Resources',
    //   items: [
    //     {
    //       label: 'Integrations',
    //       onClick: () => {
    //         navigate(paths.professionals.integrations.getHref())
    //         setIsOpen(false)
    //       },
    //     },
    //     {
    //       label: 'Blog',
    //       href: paths.blog.list.getHref(),
    //       target: '_blank',
    //     },
    //     {
    //       label: 'Help center',
    //       href: env.LINK_TO_HELP_CENTER,
    //       target: '_blank',
    //     },
    //   ],
    // },
  ]

  const iconNavItems: IconNavItem[] = [
    // {
    //   preset: 'signIn',
    //   onClick: () => {
    //     navigate(paths.alert.getHref())
    //     setIsOpen(false)
    //   },
    // },
    {
      label: 'Schedule a demo',
      icon: <CalendarOutline size={21} className="text-primary" />,
      href: CONSTANTS.LINK_TO_DEMO_FOR_PROFESSIONALS,
    },
    // {
    //   label: 'Integrations',
    //   icon: <IntegrationsOutlineIcon size={20} className="text-primary" />,
    //   onClick: () => {
    //     navigate(paths.professionals.integrations.getHref())
    //     setIsOpen(false)
    //   },
    // },
    {
      preset: 'knowledgeCenter',
      href: paths.blog.list.getHref(),
    },
    {
      preset: 'helpCenter',
      href: env.LINK_TO_HELP_CENTER,
    },
  ]

  return (
    <MobileSidebar
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="For agents & LOs"
      mainNavItems={mainNavItems}
      nestedNavItems={nestedNavItems}
      showDownloadAppFooter={true}
      iconNavItems={iconNavItems}
    />
  )
}
